<template>
  <div class="dryEyeTips">
    <p class="warningClass">
      <span>{{ warningWords }}</span>
    </p>
  </div>
</template>
<script>
import EVENTS from "../../bus";
import fileSys from "../../fileoprators/fileSystem";
export default {
  name: "dryEyeTips",
  data() {
    return {
      mode: "",
      curNibutStatus: "",
      audioSrc: "",
      willChangeTips: false,
      captureSettingTool: {
        lipidlayertime: window.captureSettings.lipidlayertime
      },
      BlinkTime: 60
    };
  },
  props: {
    modeProp: {
      type: String,
      default: "nibut"
    },
    curNibutStatusProp: {
      type: String,
      default: "focus"
    },
    willChangeTipsProp: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.BlinkTime = window.captureSettings.BlinkTime ? window.captureSettings.BlinkTime : 60;
    this.$bus.$on(EVENTS.lapidlayerVideoTime, (time) => {
      this.captureSettingTool.lipidlayertime = time;
    });
    this.$bus.$on("tip-switch", () => {
      this.BlinkTime = window.captureSettings.BlinkTime;
    });
  },
  beforeDestroy() {
    this.$bus.$off(EVENTS.lapidlayerVideoTime);
    this.$bus.$off("tip-switch");
  },
  methods: {},
  computed: {
    selfMode() {
      return this.modeProp;
    },
    selfCurNibutStatus() {
      return this.curNibutStatusProp;
    },
    selfLang() {
      let lang;
      this.willChangeTipsProp ? (lang = "zh_CN") : (lang = "en_US");
      return lang;
    },
    getCurNibutStatusChange() {
      let getCurNibutStatusChange;
      if (this.selfMode === "nibut" || this.selfMode === "fbut") {
        getCurNibutStatusChange = this.selfCurNibutStatus;
      } else {
        getCurNibutStatusChange = this.selfMode;
      }
      return getCurNibutStatusChange;
    },
    warningWords() {
      let warningWordsTip;
      let basePath = fileSys.getAudioPath();
      switch (this.getCurNibutStatusChange) {
        case "shootThreeTimes":
          warningWordsTip = this.$t("langcfg.txtFbutShootThreeTimes");
          break;
        case "focus":
          warningWordsTip = this.$t("langcfg.txtNibutFocus");
          break;
        case "firstBlinking":
          warningWordsTip = this.$t("langcfg.txtNibutFirstBlinking");
          this.$emit("change-audioSrc", `${basePath}/${this.selfLang}/blink-once.mp3`);
          break;
        case "SecondBlinking":
          warningWordsTip = this.$t("langcfg.txtNibutSecondBlinking");
          this.$emit("change-audioSrc", `${basePath}/${this.selfLang}/blink-again.mp3`);
          break;
        case "startCam":
          warningWordsTip = this.$t("langcfg.txtNibutStartCam");
          this.$emit("change-audioSrc", `${basePath}/${this.selfLang}/keep-eye-open-testing.mp3`);
          break;
        case "keep":
          warningWordsTip = this.$t("langcfg.txtNibutKeep");
          this.$emit("change-audioSrc", `${basePath}/${this.selfLang}/keep-eye-open.mp3`);
          break;
        case "end":
          warningWordsTip = this.$t("langcfg.txtNibutEnd");
          this.$emit("change-audioSrc", `${basePath}/${this.selfLang}/test-end.mp3`);
          break;
        case "cantakePhoto":
          warningWordsTip = this.$t("langcfg.txtCanShot");
          break;
        case "Manualdefault":
          if (this.modeProp === "nibut") {
            warningWordsTip = this.$t("langcfg.txtUserPlacidoNIBUT");
          } else {
            warningWordsTip = this.$t("langcfg.txtUserPlacidoFBUT");
          }
          break;
        // 非nibut
        case "lipidlayer":
          if (this.selfLang === "zh_CN") {
            warningWordsTip = `${this.$t("langcfg.txtUserPlacidoLipidlayer")}
            ${this.captureSettingTool.lipidlayertime}s
            ${this.$t("langcfg.txtUserPlacidoLipidlayerRecoup")}`;
          } else {
            warningWordsTip = `${this.$t("langcfg.txtUserPlacidoLipidlayerTake")}
            ${this.captureSettingTool.lipidlayertime}s
            ${this.$t("langcfg.txtUserPlacidoLipidlayer")}`;
          }
          break;
        case "tearheight":
          warningWordsTip = this.$t("langcfg.txtUserPlacidoTearHeight"); // 暂时无提示
          break;
        case "meibomian":
          warningWordsTip = this.$t("langcfg.txtUserPlacidoMeibimianglands");
          break;
        case "eyelidedge":
          warningWordsTip = this.$t("langcfg.txtUserPlacidoEyelidedge"); // 暂时无提示
          break;
        case "eyeredness":
          warningWordsTip = this.$t("langcfg.txtUserPlacidoEyeredness"); // 暂时无提示
          break;
        case "blink":
          warningWordsTip = `${this.$t("langcfg.txtUserPlacidoBlinkOne")}${this.BlinkTime}${this.$t("langcfg.txtUserPlacidoBlinkTwo")}`;
          break;
        case "ocularsurface":
          warningWordsTip = this.$t("langcfg.txtUserPlacidoOcularsurfacestaining");
          break;
      }
      return warningWordsTip;
    }
  }
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/mainInterface/components/dryEyeTips.vue